import { useFilter } from "context/FilterContext";
import { useGlobalContext } from "context/GlobalContext";
import { usePermissions } from "context/PermissionsContext";
import SortContext from "context/SortContext";
import RenderStock from "features/Stock/category/components/Stock.jsx";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { usePermissionFlags } from "utils/visionRights";

const Stock = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const permissions = usePermissions();
  const { setIsSetFilter, setFilterValues, setBackendFilterValues, setAppliedFilterValues, setFilterCount, filterValues } = useFilter();

  const { setSortOptions, setSearch, sortOptions, selectedSortValue } = React.useContext(SortContext);
  const { setSearchPlaceHolder, setDisplaySetIcon } = useGlobalContext();
  const { stockLocations } = usePermissionFlags();

  useEffect(() => {
    if (location.state?.innerChnages) return;
    const params = new URLSearchParams(window.location.search);
    const encoded = params.get("crmState");
    if (!encoded) return;
    try {
      const crmState = JSON.parse(atob(encoded));
      navigate("/Stock", { replace: true, state: crmState });
    } catch (_) {}
  }, []);

  useEffect(() => {
    setSearch("");
    setSortOptions([
      { id: 1, name: "Alphabetical Quote (A to Z)", sortBy: "alphabetical", order: "asc" },
      { id: 2, name: "Alphabetical Quote (Z to A)", sortBy: "alphabetical", order: "desc" },
      { id: 3, name: "Stocks (High to Low)", sortBy: "quantity", order: "desc" },
      { id: 4, name: "Stocks (Low to High)", sortBy: "quantity", order: "asc" },
    ]);
    setIsSetFilter(true);
    setSearchPlaceHolder("Search By Jewel Code or Design Number");
    setDisplaySetIcon(true);
    return () => {
      setSearchPlaceHolder("Search");
      setIsSetFilter(false);
      setBackendFilterValues({});
      setFilterValues({});
      setSortOptions([]);
      setSearch("");
      setDisplaySetIcon(false);
      sessionStorage.removeItem("appliedSortValue");
      // setFilterCount(0);
      // sessionStorage.setItem("filterChangeCount", 0);
      // setAppliedFilterValues({});
    };
  }, []);

  useEffect(() => {
    sessionStorage.setItem("appliedSortValue", selectedSortValue);
  }, [selectedSortValue, sortOptions]);

  useEffect(() => {
    console.log(stockLocations);

    let filterData = {
      Location: stockLocations?.length > 0 ? stockLocations : [],
      "Stock Status": ["All", "On Hand", "On Memo"],
    };

    setBackendFilterValues(filterData);
    setFilterValues((prev) => ({
      ...filterData,
      // Location: prev?.Location?.length ? prev.Location : filterData.Location,
      "Stock Status": prev["Stock Status"] ? prev["Stock Status"] : filterData["Stock Status"],
    }));

    let filterChangeCount = JSON.parse(sessionStorage.getItem("filterChangeCount"));

    if (filterChangeCount === 0) {
      setFilterValues((prev) => ({
        ...filterData,
        "Stock Status": prev["Stock Status"] ? prev["Stock Status"] : filterData["Stock Status"],
      }));

      sessionStorage.setItem(
        "appliedFilterValues",
        JSON.stringify(filterData)
      );
    } else {
      const savedFilters = JSON.parse(
        sessionStorage.getItem("appliedFilterValues") || "{}"
      );

      const newFilters = {
        Location: savedFilters.Location || filterData?.Location || [],
        "Stock Status": savedFilters["Stock Status"] || ["All", "On Hand", "On Memo"],
      };
      setFilterValues(newFilters);
    }
  }, [permissions]);

  useEffect(() => {
    setSearch(location?.state?.stockSearch || "");
  }, [location]);

  return <RenderStock />;
};

export default Stock;
